{
  "entities": {
    "warehouses": "仓库 | 仓库",
    "loadtypes": "货物类型 | 货物类型",
    "organizations": "组织 | 组织",
    "orgs": "组织 | 组织"
  }
}
